export const FILTER_MENU_ITEM = {
  SIZES: 'sizes',
  CATEGORIES: 'categories',
  CATEGORY: 'category',
  PARENT_CATEGORY: 'parentcategory',
  BRANDS: 'brands',
  ORDER: 'order',
  CONDITIONS: 'conditions',
  PRICE: 'price',
  COLORS: 'colors',
  SECTION: 'section',
  MATERIALS: 'materials',
} as const;

export type FilterMenuItemType = (typeof FILTER_MENU_ITEM)[keyof typeof FILTER_MENU_ITEM];
